import L from 'leaflet';
import type { geocoders } from 'leaflet-control-geocoder';
import { VasttrafikApiClient } from './VasttrafikApiClient';

type GeocodingResult = geocoders.GeocodingResult;

type LegacyGeocoder = {
    geocode: (query: string, callback: (results: GeocodingResult[]) => void, context?: object) => void;
    suggest: (query: string, callback: (results: GeocodingResult[]) => void, context?: object) => void;
    reverse: (latlng: L.LatLng, scale: number | undefined, callback: (results: GeocodingResult[]) => void, context?: object) => void;
};

export class VasttrafikGeocoder implements geocoders.IGeocoder {
    private _vasttrafikApiClient: VasttrafikApiClient;

    constructor() {
        this._vasttrafikApiClient = new VasttrafikApiClient('https://ext-api.vasttrafik.se/pr/v4');
    }
    async geocode(query: string): Promise<GeocodingResult[]> {
        const locationsResponse = await this._vasttrafikApiClient.getLocationsByText(query);

        return locationsResponse.results.map((location) => {
            const position = new L.LatLng(location.latitude, location.longitude);
            return {
                name: location.name,
                center: position,
                bbox: new L.LatLngBounds(position, position),
            };
        });
    }

    suggest(query: string): Promise<GeocodingResult[]> {
        return this.geocode(query);
    }

    async reverse(location: L.LatLngLiteral): Promise<GeocodingResult[]> {
        const addressesResponse = await this._vasttrafikApiClient.getLocationsByCoordinates(location.lat, location.lng);

        if (addressesResponse.results.length === 0) {
            return [];
        }

        return addressesResponse.results.map((address) => {
            const position = new L.LatLng(address.latitude, address.longitude);
            return {
                name: address.name,
                center: position,
                bbox: new L.LatLngBounds(position, position),
            };
        });
    }

    asLegacyGeocoder(): LegacyGeocoder {
        return {
            geocode: (query, callback, context) => {
                void this.geocode(query).then((results) => callback.call(context, results));
            },
            suggest: (query, callback, context) => {
                void this.suggest(query).then((results) => callback.call(context, results));
            },
            reverse: (latlng, _scale, callback, context) => {
                void this.reverse(latlng).then((results) => callback.call(context, results));
            },
        };
    }
}

export default VasttrafikGeocoder;
